"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _TextInput = _interopRequireDefault(require("../text-input/TextInput"));

var _DatePicker = _interopRequireDefault(require("./DatePicker"));

var Popover = _interopRequireWildcard(require("@radix-ui/react-popover"));

var _customParseFormat = _interopRequireDefault(require("dayjs/plugin/customParseFormat"));

var _uuid = require("uuid");

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

_dayjs["default"].extend(_customParseFormat["default"]);

var calendarIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
}));

var getValueForPicker = function getValueForPicker(value, format) {
  return (0, _dayjs["default"])(value, format.toUpperCase(), true);
};

var DxcDateInput = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var label = _ref.label,
      name = _ref.name,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? "" : _ref$defaultValue,
      value = _ref.value,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? "dd-MM-yyyy" : _ref$format,
      helperText = _ref.helperText,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? false : _ref$placeholder,
      clearable = _ref.clearable,
      disabled = _ref.disabled,
      optional = _ref.optional,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      error = _ref.error,
      autocomplete = _ref.autocomplete,
      margin = _ref.margin,
      size = _ref.size,
      tabIndex = _ref.tabIndex;

  var _useState = (0, _react.useState)(defaultValue),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      innerValue = _useState2[0],
      setInnerValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var _useState5 = (0, _react.useState)("date-picker-".concat((0, _uuid.v4)())),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 1),
      calendarId = _useState6[0];

  var colorsTheme = (0, _useTheme["default"])();
  var translatedLabels = (0, _useTranslatedLabels["default"])();
  var dateRef = (0, _react.useRef)(null);
  (0, _react.useLayoutEffect)(function () {
    if (!disabled) {
      var actionButtonRef = dateRef === null || dateRef === void 0 ? void 0 : dateRef.current.querySelector("[title='Open calendar']");
      actionButtonRef === null || actionButtonRef === void 0 ? void 0 : actionButtonRef.setAttribute("aria-haspopup", true);
      actionButtonRef === null || actionButtonRef === void 0 ? void 0 : actionButtonRef.setAttribute("role", "combobox");
      actionButtonRef === null || actionButtonRef === void 0 ? void 0 : actionButtonRef.setAttribute("aria-expanded", isOpen);
      actionButtonRef === null || actionButtonRef === void 0 ? void 0 : actionButtonRef.setAttribute("aria-controls", calendarId);
      actionButtonRef === null || actionButtonRef === void 0 ? void 0 : actionButtonRef.setAttribute("aria-describedby", calendarId);
    }
  }, [isOpen, disabled, calendarId]);

  var handleCalendarOnClick = function handleCalendarOnClick(newDate) {
    var newValue = newDate.format(format.toUpperCase());
    value !== null && value !== void 0 ? value : setInnerValue(newValue);
    newDate !== null && newDate !== void 0 && newDate.set("day", newDate.get("date")).toJSON() ? onChange === null || onChange === void 0 ? void 0 : onChange({
      value: newValue,
      date: newDate
    }) : onChange === null || onChange === void 0 ? void 0 : onChange({
      value: newValue
    });
  };

  var handleIOnChange = function handleIOnChange(_ref2) {
    var newValue = _ref2.value,
        inputError = _ref2.error;
    value !== null && value !== void 0 ? value : setInnerValue(newValue);
    var dayjsDate = getValueForPicker(newValue, format);
    var invalidDateMessage = newValue !== "" && !dayjsDate.isValid() && translatedLabels.dateInput.invalidDateErrorMessage;
    var callbackParams = inputError || invalidDateMessage ? {
      value: newValue,
      error: inputError || invalidDateMessage
    } : {
      value: newValue
    };
    dayjsDate.isValid() ? onChange === null || onChange === void 0 ? void 0 : onChange(_objectSpread(_objectSpread({}, callbackParams), {}, {
      date: dayjsDate.toDate()
    })) : onChange === null || onChange === void 0 ? void 0 : onChange(callbackParams);
  };

  var handleIOnBlur = function handleIOnBlur(_ref3) {
    var value = _ref3.value,
        inputError = _ref3.error;
    var dayjsDate = getValueForPicker(value, format);
    var invalidDateMessage = value !== "" && !dayjsDate.isValid() && translatedLabels.dateInput.invalidDateErrorMessage;
    var callbackParams = inputError || invalidDateMessage ? {
      value: value,
      error: inputError || invalidDateMessage
    } : {
      value: value
    };
    dayjsDate.isValid() ? onBlur === null || onBlur === void 0 ? void 0 : onBlur(_objectSpread(_objectSpread({}, callbackParams), {}, {
      date: dayjsDate.toDate()
    })) : onBlur === null || onBlur === void 0 ? void 0 : onBlur(callbackParams);
  };

  var openCalendar = function openCalendar() {
    setIsOpen(!isOpen);
  };

  var closeCalendar = function closeCalendar() {
    setIsOpen(false);
  };

  var handleDatePickerEscKeydown = function handleDatePickerEscKeydown(event) {
    event.preventDefault();
    closeCalendar();
    dateRef === null || dateRef === void 0 ? void 0 : dateRef.current.getElementsByTagName("input")[0].focus();
  };

  var handleDatePickerOnBlur = function handleDatePickerOnBlur(event) {
    if (!(event !== null && event !== void 0 && event.currentTarget.contains(event.relatedTarget))) closeCalendar();
  };

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(Popover.Root, {
    open: isOpen
  }, /*#__PURE__*/_react["default"].createElement(Popover.Trigger, {
    asChild: true,
    "aria-controls": undefined
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: label,
    name: name,
    defaultValue: defaultValue,
    value: value !== null && value !== void 0 ? value : innerValue,
    helperText: helperText,
    placeholder: placeholder ? format.toUpperCase() : null,
    action: {
      onClick: openCalendar,
      icon: calendarIcon,
      title: "Open calendar"
    },
    clearable: clearable,
    disabled: disabled,
    optional: optional,
    onChange: handleIOnChange,
    onBlur: handleIOnBlur,
    error: error,
    autocomplete: autocomplete,
    margin: margin,
    size: size,
    tabIndex: tabIndex,
    ref: dateRef
  })), /*#__PURE__*/_react["default"].createElement(StyledContent, {
    sideOffset: error ? -18 : 2,
    align: "end",
    "aria-modal": true,
    onBlur: handleDatePickerOnBlur,
    onEscapeKeyDown: handleDatePickerEscKeydown,
    avoidCollisions: false
  }, /*#__PURE__*/_react["default"].createElement(_DatePicker["default"], {
    id: calendarId,
    onDateSelect: handleCalendarOnClick,
    date: getValueForPicker(value !== null && value !== void 0 ? value : innerValue, format.toUpperCase())
  })))));
});

var StyledContent = (0, _styledComponents["default"])(Popover.Content)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  &:focus-visible {\n    outline: none;\n  }\n"])));
var _default = DxcDateInput;
exports["default"] = _default;